export function validateUser(user, organizationRoles, role, update = false) {
    let correctUserInfo = true;
    const { simpalsLogin, simpalsId, name, accesses } = user;
    if (
        name === '' ||
        simpalsLogin === '' ||
        accesses.length === 0
    ) {
        correctUserInfo = false;
    }
    accesses?.map(access => {
        const isOrganizationRole = organizationRoles.includes(access.role);
        if (access.role === '' || (access.role === role.cashier) && user.cashRegisters.length === 0 ) {
            correctUserInfo = false;
        }
    });
    return correctUserInfo;
}

export function validateUserName(user) {
    let correctUserInfo = true;
    const { simpalsId, name } = user;
    if (name === '' || simpalsId === '') {
        correctUserInfo = false;
    }
    return correctUserInfo;
}

